interface ImpliedConfirmedNetValueOptions {
  confirmedGross?: number | null;
  originalGross?: number | null;
  originalNet?: number | null;
}

const VEHICLE_VALUATION_PRICE_ROUNDING_INCREMENT = 50;

export function roundVehicleValuationPriceForDisplay(value: number): number;
export function roundVehicleValuationPriceForDisplay(value: null): null;
export function roundVehicleValuationPriceForDisplay(value: undefined): undefined;
export function roundVehicleValuationPriceForDisplay(value: number | null | undefined): number | null | undefined {
  if (value == null) {
    return value;
  }

  const roundedMagnitude =
    Math.round(Math.abs(value) / VEHICLE_VALUATION_PRICE_ROUNDING_INCREMENT) *
    VEHICLE_VALUATION_PRICE_ROUNDING_INCREMENT;

  return Math.sign(value) * roundedMagnitude;
}

export function getImpliedConfirmedNetValue({
  confirmedGross,
  originalGross,
  originalNet,
}: ImpliedConfirmedNetValueOptions): number | null {
  if (originalNet == null || originalGross == null || originalGross === 0 || confirmedGross == null) {
    return null;
  }

  return Number(((confirmedGross / originalGross) * originalNet).toFixed(2));
}

export function getValuationNumberDifference(
  currentValue?: number | null,
  previousValue?: number | null,
): number | undefined {
  if (currentValue == null || previousValue == null) {
    return undefined;
  }

  return currentValue - previousValue;
}
